import React, { Fragment, useEffect, useState } from "react";

import {
  Navbar,
  Nav,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  NavbarBrand,
  NavItem,
  NavLink,
  Badge,
} from "reactstrap";

import { useNavigate } from "react-router-dom";

//Unform e componentes
import TooltipItem from "../componentes/TooltipItem";
import AvisoVersaoAdm from "../componentes/AvisoVersaoAdm";

//Context
import { useAuth } from "../context/auth";

//Common
import { fn_isValidNumber } from "@/common/utils/util";
import {
  ID_PARAMETRIZACAO,
  ID_USUARIO_SYSTEM,
  PATH_FERRAMENTA_ADM_SYSTEM,
  POSICAO_MENU,
} from "@/common/constantes";

//Util
import { ICONES_MENU, ICONES_MENU_ITEM } from "../utils/icones";
import { fn_getPosicaoMenu } from "../utils/menu";
import { fn_getPathTenant } from "../utils/sessao";
import { MENSAGENS_AVISO, showMensagemAviso } from "../utils/mensagens";
import {
  fn_getDataUltimoLogin,
  fn_getMenusUsuario,
  fn_getUsuario,
  fn_usuarioIsSystem,
} from "../utils/sessao";

//API
import { api_findUniqueParametrizacaoTenant } from "../services/api/api_find";
import { api_salvarLogin } from "../services/api/api_iud";
import { api_getCountNotificacaoNaoLida } from "../services/api/api_others";

//Telas
import TUsuario_alterar_senha from "./acesso/usuario/usuario_alterar_senha";
import TNotificacao_usuario from "./acesso/notificacao/notificacao_usuario";
import MenuLateral from "./menu_lateral";

//Chave do navegador que guarda se o usuário deixou o menu lateral recolhido
const CHAVE_MENU_LATERAL_RECOLHIDO = "siigMenuLateralRecolhido";

function Header({ sessaoUsuario }) {
  return (
    <div className="header">
      <DynamicMenu sessaoUsuario={sessaoUsuario} />
    </div>
  );
}

const DynamicMenu = React.memo(({ sessaoUsuario }) => {
  const { signOut } = useAuth();
  const navigate = useNavigate();

  const usuarioLogado = fn_getUsuario(sessaoUsuario);
  const menus = fn_getMenusUsuario(sessaoUsuario);

  //### USE STATE ###
  const [modalOpenAltSenha, setModalOpenAltSenha] = useState(false);
  const [modalOpenNotificacoes, setModalOpenNotificacoes] = useState(false);

  const [menuOpen, setMenuOpen] = useState({});
  const [menuUserOpen, setMenuUserOpen] = useState(false);

  const [pathTenant, setPathTenat] = useState(null);

  const [valorParamPrimAcesso, setValorParamPrimAcesso] = useState(false);
  const [countNotifNaoLida, setCountNotifNaoLida] = useState(0);

  //Menu lateral recolhido (só os ícones): escolha guardada no navegador do usuário
  const [menuLateralRecolhido, setMenuLateralRecolhido] = useState(() => {
    try {
      return localStorage.getItem(CHAVE_MENU_LATERAL_RECOLHIDO) == "S";
    } catch (error) {
      return false;
    }
  });

  //### VARIÁVEIS AUXILIARES ###
  //Menu na lateral esquerda ou no topo (parametrização global POSICAO_MENU, guardada na sessão no login)
  const isMenuLateral = fn_getPosicaoMenu(sessaoUsuario) == POSICAO_MENU.LATERAL;

  //### USE EFFECT ###
  //Inicialização da tela
  useEffect(() => {
    //Carrega as infomações necessárias ao logar
    async function loadInformacoes() {
      const path = fn_getPathTenant(sessaoUsuario);

      setPathTenat(path);
      verificarPrimeiroAcesso();

      if (path != PATH_FERRAMENTA_ADM_SYSTEM) {
        await getCountNotificacaoNaoLida(); //chama fora do interval para já carregar de imediato ao logar

        //Obtém a parametrização do tempo de reload das notificações
        const paramReloadNotificacao = await api_findUniqueParametrizacaoTenant(
          ID_PARAMETRIZACAO.RELOAD_NOTIFICACAO,
        );

        //padrão a cada 5 minutos
        let tempoMilissegundos = 300000;
        if (paramReloadNotificacao) {
          if (fn_isValidNumber(paramReloadNotificacao.valor)) {
            tempoMilissegundos = Number(paramReloadNotificacao.valor) * 60000;
          }
        }

        let interval = setInterval(
          getCountNotificacaoNaoLida,
          tempoMilissegundos,
        );
        // Retorna uma função de limpeza que será executada quando o componente for desmontado
        return () => clearInterval(interval);
      }
    }

    loadInformacoes();
  }, []);

  //### FUNCOES ###
  //Verifica se é o primeiro acesso do usuário para apresentar a tela de alteração de senha
  async function verificarPrimeiroAcesso() {
    let salvarAcesso = true;

    if (
      sessaoUsuario &&
      !fn_usuarioIsSystem(sessaoUsuario) &&
      !fn_getDataUltimoLogin()
    ) {
      //Obtém a parametrização para saber se obriga a alteração da senha no primeiro acesso
      const param = await api_findUniqueParametrizacaoTenant(
        ID_PARAMETRIZACAO.ALTERACAO_SENHA_PRIMEIRO_ACESSO,
      );

      if (param) {
        //Se obrigar a alteração da senha
        if (param.valor == "O") {
          showMensagemAviso(MENSAGENS_AVISO.PRIMEIRO_ACESSO, "obrigatório");
          //Se a alteraçao da senha for obrigatória no primeiro acesso, só vai salvar o acesso na tela da alteração da senha
          salvarAcesso = false;
        }
        //Se recomendar a alteração da senha
        else if (param.valor == "R") {
          showMensagemAviso(MENSAGENS_AVISO.PRIMEIRO_ACESSO, "recomendado");
        }
        setValorParamPrimAcesso(param.valor);
        setModalOpenAltSenha(true);
      }
    }

    if (salvarAcesso && usuarioLogado) {
      //Salva a data do login
      await api_salvarLogin(usuarioLogado.id);
    }
  }

  //Obtém a quantidade de notificações não lidas do usuário
  async function getCountNotificacaoNaoLida() {
    if (usuarioLogado) {
      setCountNotifNaoLida(
        await api_getCountNotificacaoNaoLida(usuarioLogado.id),
      );
    }
  }

  //### EVENTOS ###
  //OnClick Menu
  function toggleMenu(id) {
    setMenuOpen((prevMenuOpen) => ({
      ...prevMenuOpen,
      [id]: !prevMenuOpen[id],
    }));
  }

  //OnClick - Menu Home
  function handleMenuHome() {
    if (pathTenant == PATH_FERRAMENTA_ADM_SYSTEM) {
      navigate("/dashboard_system");
    } else {
      navigate("/dashboard");
    }
  }

  //OnClick - Botão abrir/recolher o menu lateral (guarda a escolha no navegador do usuário)
  function handleRecolherMenuLateral(recolher) {
    setMenuLateralRecolhido(recolher);

    try {
      localStorage.setItem(CHAVE_MENU_LATERAL_RECOLHIDO, recolher ? "S" : "N");
    } catch (error) {
      //sem acesso ao armazenamento do navegador: a escolha vale só até recarregar a página
    }
  }

  //OnClick - Item menu
  function handleItemMenu(item) {
    const rota = item?.tela?.link || item?.tela?.rota || item?.rota;
    if (rota) navigate(rota);
  }

  //OnClick Item menu - Alterar senha
  function handleItemMenuAlterarSenha() {
    setValorParamPrimAcesso(null);
    setModalOpenAltSenha(true);
  }

  //OnClick Item menu - Notificações
  function handleItemMenuNotificacoes() {
    setModalOpenNotificacoes(true);
  }

  //OnClick Item menu - Sair
  function handleItemMenuSair() {
    signOut();

    if (pathTenant) {
      navigate(`/login/${pathTenant}`);
    } else {
      navigate("/home");
    }
  }

  return (
    <div className="content-menu">
      <div className="header">
        <div className="dropdown">
          {/* MENU LATERAL: no header ficam o botão de abrir/recolher o menu e o Dashboard */}
          {isMenuLateral && (
            <>
              <button
                type="button"
                className="menu-lateral-botao-header"
                title={menuLateralRecolhido ? "Abrir menu" : "Recolher menu"}
                aria-label={
                  menuLateralRecolhido ? "Abrir menu" : "Recolher menu"
                }
                onClick={() => handleRecolherMenuLateral(!menuLateralRecolhido)}
              >
                {menuLateralRecolhido
                  ? ICONES_MENU.MENU_LATERAL_ABRIR
                  : ICONES_MENU.MENU_LATERAL_RECOLHER}
              </button>

              {/* MENU DASHBOARD (igual ao do menu no topo) */}
              <Navbar expand="sm">
                <Nav navbar>
                  <NavItem>
                    <NavLink
                      className="menu-drop-toggle cursor-pointer"
                      onClick={handleMenuHome}
                    >
                      <div className="d-flex align-items-center text-nowrap">
                        <div style={{ fontSize: "12px" }}>
                          {ICONES_MENU.HOME}
                        </div>

                        <div className="ms-1">Dashboard</div>
                      </div>
                    </NavLink>
                  </NavItem>
                </Nav>
              </Navbar>
            </>
          )}

          {/* MENU NO TOPO */}
          {!isMenuLateral && (
            <Navbar expand="sm">
              {/* <NavbarBrand>
              <div className="d-flex align-items-center">
                <div
                  className="menu-dashboard cursor-pointer mb-2"
                  title="Dashboard"
                  onClick={handleMenuHome}
                  style={{ fontSize: "20px" }}
                >
                  {ICONES_MENU.HOME}
                </div>
              </div>
            </NavbarBrand> */}

              <Nav navbar>
                {/* MENU DASHBOARD */}
                <NavItem>
                  <NavLink
                    className="menu-drop-toggle cursor-pointer"
                    onClick={handleMenuHome}
                  >
                    <div className="d-flex align-items-center text-nowrap">
                      <div style={{ fontSize: "12px" }}>{ICONES_MENU.HOME}</div>

                      <div className="ms-1">Dashboard</div>
                    </div>
                  </NavLink>
                </NavItem>

                {Array.isArray(menus) &&
                  menus.map((menu) => (
                    <Fragment key={menu.id}>
                      <Dropdown
                        nav
                        isOpen={menuOpen[menu.id] || false}
                        toggle={() => toggleMenu(menu.id)}
                      >
                        <DropdownToggle nav className="menu-drop-toggle">
                          <div className="d-flex align-items-center text-nowrap">
                            <div style={{ fontSize: "12px" }}>
                              {menu.icone ? ICONES_MENU[menu.icone] : ""}
                            </div>

                            <div className="ms-1">{menu.nome}</div>
                          </div>
                        </DropdownToggle>

                        <DropdownMenu>
                          {menu.itens.map((item, index) => (
                            <Fragment key={item.id}>
                              {item?.divisor && //acrescenta divisor
                                item.divisor.trim() == "S" &&
                                index > 0 && (
                                  <DropdownItem
                                    divider
                                    className="menu-drop-item-divisor"
                                  />
                                )}

                              <DropdownItem
                                onClick={() => handleItemMenu(item)}
                              >
                                {item.icone ? ICONES_MENU[item.icone] : ""}{" "}
                                {item.nome}
                              </DropdownItem>
                            </Fragment>
                          ))}
                        </DropdownMenu>
                      </Dropdown>
                    </Fragment>
                  ))}
              </Nav>
            </Navbar>
          )}

          {/* NOTIFICAÇÃO */}
          <div className="notificacao me-2">
            {pathTenant != PATH_FERRAMENTA_ADM_SYSTEM && (
              <TooltipItem text="Notificações não lidas">
                <div
                  className="ms-2 d-flex align-items-center"
                  onClick={handleItemMenuNotificacoes}
                >
                  <span style={{ fontSize: "26px" }}>
                    {ICONES_MENU_ITEM.NOTIFICACAO}
                  </span>

                  <Badge
                    className={
                      countNotifNaoLida > 0
                        ? "notificacao-menu-nao-lido"
                        : "notificacao-menu"
                    }
                  >
                    {countNotifNaoLida ?? ""}
                  </Badge>
                </div>
              </TooltipItem>
            )}
          </div>

          {/* MENU USUARIO */}
          <div className="user me-4">
            <Nav navbar>
              <Dropdown
                nav
                isOpen={menuUserOpen}
                toggle={() => setMenuUserOpen(!menuUserOpen)}
              >
                <DropdownToggle nav className="menu-drop-toggle">
                  <div className="d-flex align-items-center justify-content-end">
                    <span className="mt-3 me-2">
                      {usuarioLogado.nome.split(" ")[0]}
                    </span>
                    <div style={{ fontSize: "26px" }}>
                      <span>{ICONES_MENU.AVATAR}</span>
                    </div>
                  </div>
                </DropdownToggle>

                <DropdownMenu>
                  {usuarioLogado.id != ID_USUARIO_SYSTEM && (
                    <React.Fragment>
                      <DropdownItem onClick={handleItemMenuAlterarSenha}>
                        {ICONES_MENU_ITEM.ALTERAR_SENHA} Alterar senha
                      </DropdownItem>

                      <DropdownItem divider />
                    </React.Fragment>
                  )}

                  <DropdownItem onClick={handleItemMenuSair}>
                    {ICONES_MENU_ITEM.LOGOUT} Sair
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </Nav>
          </div>
        </div>
      </div>

      {/* MENU LATERAL */}
      {isMenuLateral && (
        <MenuLateral
          menus={Array.isArray(menus) ? menus : []}
          recolhido={menuLateralRecolhido}
          onRecolher={handleRecolherMenuLateral}
        />
      )}

      {/* AVISO DE NOVA VERSÃO (somente no SIIG Administrativo) */}
      {pathTenant == PATH_FERRAMENTA_ADM_SYSTEM && <AvisoVersaoAdm />}

      {/* MODAL NOTIFICACOES */}
      {modalOpenNotificacoes && (
        <div>
          <TNotificacao_usuario
            modalOpen={modalOpenNotificacoes}
            toggleModal={() => setModalOpenNotificacoes(!modalOpenNotificacoes)}
            countNotifNaoLida={countNotifNaoLida}
            setCountNotifNaoLida={setCountNotifNaoLida}
          />
        </div>
      )}

      {/* MODAL ALTERAR SENHA */}
      {modalOpenAltSenha && (
        <div>
          <TUsuario_alterar_senha
            modalOpen={modalOpenAltSenha}
            toggleModal={() => setModalOpenAltSenha(!modalOpenAltSenha)}
            usuarioEdit={usuarioLogado}
            redefinir={false}
            valorParamPrimAcesso={valorParamPrimAcesso}
          />
        </div>
      )}
    </div>
  );
});

export default Header;
